const MESSAGE_FALLBACK_ORDER = ['en_us', 'zh_cn'];

export function resolveApiMessage(message, language, fallback = '') {
  if (typeof message === 'string') {
    return message || fallback;
  }

  if (!message || typeof message !== 'object') {
    return fallback;
  }

  const normalizedLanguage = typeof language === 'string' ? language.toLowerCase() : '';
  const candidates = [normalizedLanguage, ...MESSAGE_FALLBACK_ORDER];

  for (const key of candidates) {
    if (key && typeof message[key] === 'string' && message[key].trim() !== '') {
      return message[key];
    }
  }

  for (const value of Object.values(message)) {
    if (typeof value === 'string' && value.trim() !== '') {
      return value;
    }
  }

  return fallback;
}
